// extracted by mini-css-extract-plugin
module.exports = {"adviceLink":"c5DQng1","important":"lF8i0h"};